/* Abnormal — theme.js (vanilla, no build step) */
(function () {
  "use strict";

  /* ---------- Dark mode ---------- */
  var STORAGE_KEY = "abnormal-theme-mode";

  function applyMode(mode) {
    if (mode === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
    }
  }

  function initModeToggle() {
    var btn = document.querySelector("[data-mode-toggle]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var current = document.documentElement.getAttribute("data-theme");
      var next = current === "dark" ? "light" : "dark";
      applyMode(next);
      try { localStorage.setItem(STORAGE_KEY, next); } catch (e) {}
    });
  }

  /* ---------- Mobile nav ---------- */
  function initNavToggle() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-site-nav]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("is-open");
        document.body.style.overflow = "";
      });
    });
  }

  /* ---------- Touch placard tap ---------- */
  function initTouchPlacards() {
    if (!window.matchMedia("(hover: none)").matches) return;
    document.querySelectorAll(".card[data-tap-card]").forEach(function (card) {
      card.addEventListener("click", function (e) {
        var alreadyActive = card.classList.contains("is-active");
        if (!alreadyActive) {
          e.preventDefault();
          document.querySelectorAll(".card.is-active").forEach(function (c) {
            if (c !== card) c.classList.remove("is-active");
          });
          card.classList.add("is-active");
        }
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll(".reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    var main = document.querySelector("[data-product-main-img]");
    var thumbs = document.querySelectorAll("[data-product-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full-src");
        var alt = thumb.getAttribute("data-alt") || "";
        if (src) {
          main.querySelector("img").setAttribute("src", src);
          main.querySelector("img").setAttribute("alt", alt);
        }
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split(".");
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (!format) return "$" + withCommas + "." + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + "." + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas + "," + parts[1]);
  }

  function initVariantPickers() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var jsonEl = form.querySelector("[data-product-json]");
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var selects = form.querySelectorAll("[data-option-selector]");
      var idInput = form.querySelector("[data-variant-id-input]");
      var priceEl = form.closest(".product__info")
        ? form.closest(".product__info").querySelector("[data-product-price]")
        : null;
      var addBtn = form.querySelector("[data-add-to-cart]");
      var addBtnText = form.querySelector("[data-add-to-cart-text]");
      var moneyFormat = form.getAttribute("data-money-format");

      function currentSelection() {
        var vals = [];
        selects.forEach(function (s) { vals.push(s.value); });
        return vals;
      }

      function findVariant(values) {
        return product.variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return values.length === 0 || opt === values[i];
          });
        });
      }

      function updateUI(variant) {
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML =
              "<s>" + formatMoney(variant.compare_at_price, moneyFormat) + "</s>" +
              formatMoney(variant.price, moneyFormat);
          } else {
            priceEl.textContent = formatMoney(variant.price, moneyFormat);
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addBtnText) addBtnText.textContent = variant.available ? "Add to cart" : "Sold out";
        }
      }

      selects.forEach(function (select) {
        select.addEventListener("change", function () {
          var variant = findVariant(currentSelection());
          updateUI(variant);
        });
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQuantity() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      wrap.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = btn.getAttribute("data-step") === "down" ? -1 : 1;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initModeToggle();
    initNavToggle();
    initTouchPlacards();
    initReveal();
    initProductGallery();
    initVariantPickers();
    initQuantity();
  });
})();
